// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__XWpSd","SiteLegal":"Footer_SiteLegal__3bALS"};